var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 6.60938C16.875 11.5312 9.57726 15.5152 9.26648 15.6797C9.18457 15.7238 9.09301 15.7468 9 15.7468C8.90699 15.7468 8.81543 15.7238 8.73352 15.6797C8.42273 15.5152 1.125 11.5312 1.125 6.60938C1.1263 5.4536 1.58601 4.34553 2.40327 3.52827C3.22053 2.71101 4.3286 2.2513 5.48438 2.25C6.93633 2.25 8.20758 2.87437 9 3.92977C9.79242 2.87437 11.0637 2.25 12.5156 2.25C13.6714 2.2513 14.7795 2.71101 15.5967 3.52827C16.414 4.34553 16.8737 5.4536 16.875 6.60938Z",
    fill: "#EB5757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.07d14d12e3542a2cda3d5c3fd0d29289.svg";
export { ForwardRef as ReactComponent };